import PropTypes from 'prop-types';
import { Drawer, Tag, Avatar, Space } from 'antd';
import Moment from 'react-moment';
import moment from 'moment-timezone';
import { UserOutlined } from '@ant-design/icons';
import PipelineSteps from './PipelineSteps';
import formatDuration from '../../helpers/formatDuration';
import styles from './DeploymentDetailDrawer.module.scss';

function StatutTag({ statut }) {
    if (statut === 'succes') return <Tag color="success">Succès</Tag>;
    if (statut === 'echec') return <Tag color="error">Échec</Tag>;
    if (statut === 'en_cours') return <Tag color="processing">En cours</Tag>;
    return <Tag>—</Tag>;
}
StatutTag.propTypes = { statut: PropTypes.string };

export default function DeploymentDetailDrawer({ deploiement, environnements, onClose }) {
    const dureeTotale = deploiement?.demarre_le && deploiement?.termine_le
        ? formatDuration(moment(deploiement.termine_le).diff(moment(deploiement.demarre_le)))
        : null;

    return (
        <Drawer
            title={deploiement?.statut === 'en_cours' ? 'Suivi en direct du déploiement' : 'Détail du déploiement'}
            width={780}
            open={!!deploiement}
            onClose={onClose}
            destroyOnClose
        >
            {deploiement && (
                <div className={styles.drawer}>
                    <div className={styles.summary}>
                        <div className={styles.summaryItem}>
                            <span className={styles.summaryLabel}>Statut</span>
                            <StatutTag statut={deploiement.statut} />
                        </div>
                        <div className={styles.summaryItem}>
                            <span className={styles.summaryLabel}>Déclenché par</span>
                            <Space size={6}>
                                <Avatar size={20} icon={<UserOutlined />} src={deploiement.declenche_par?.avatar} />
                                {deploiement.declenche_par?.name ?? deploiement.declenche_par?.email ?? 'N/A'}
                            </Space>
                        </div>
                        <div className={styles.summaryItem}>
                            <span className={styles.summaryLabel}>Démarré</span>
                            {deploiement.demarre_le ? <Moment format="DD/MM/YYYY HH:mm:ss">{deploiement.demarre_le}</Moment> : 'N/A'}
                        </div>
                        <div className={styles.summaryItem}>
                            <span className={styles.summaryLabel}>Durée totale</span>
                            {dureeTotale ?? (deploiement.statut === 'en_cours' ? 'En cours…' : 'N/A')}
                        </div>
                    </div>

                    {(deploiement.cibles ?? []).map((code) => {
                        const data = deploiement.resultat?.[code] ?? { steps: [] };
                        const label = environnements.find((e) => e.code === code)?.label ?? code;
                        return (
                            <div key={code} className={styles.targetSection}>
                                <div className={styles.targetHeader}>
                                    <span className={styles.targetLabel}>{label}</span>
                                    <StatutTag statut={data.statut} />
                                </div>
                                {data.erreur && <div className={styles.erreur}>{data.erreur}</div>}
                                <PipelineSteps steps={data.steps} />
                            </div>
                        );
                    })}
                </div>
            )}
        </Drawer>
    );
}

DeploymentDetailDrawer.propTypes = {
    deploiement: PropTypes.shape({
        uid: PropTypes.string,
        statut: PropTypes.string,
        cibles: PropTypes.array,
        resultat: PropTypes.object,
        demarre_le: PropTypes.string,
        termine_le: PropTypes.string,
        declenche_par: PropTypes.object,
    }),
    environnements: PropTypes.array.isRequired,
    onClose: PropTypes.func.isRequired,
};
